import { useEffect, useState } from 'react';

import { isSeen } from '../utils';

export const useActive = ({
    tooltipStorageKey,
    endOfLife,
}: {
    tooltipStorageKey?: string;
    endOfLife?: number;
}): [boolean, (boolean) => void] => {
    const hasBeenSeen = isSeen(tooltipStorageKey);
    const passedEndOfLife = endOfLife ? Date.now() > endOfLife : false;
    const [active, setActive] = useState(!hasBeenSeen && !passedEndOfLife);

    useEffect(() => {
        if (!endOfLife || !active) {
            return;
        }

        const timeoutId = setTimeout(() => {
            setActive(false);
        }, endOfLife - Date.now());

        return () => {
            clearTimeout(timeoutId);
        };
    }, [endOfLife, active]);

    return [active, setActive];
};
